export default class GaTrackApply {
	constructor() {
        this.$trackBtns = document.querySelectorAll('[data-track]');

        this.$trackBtns.forEach(element => {
            element.addEventListener('click', this.track.bind(this));
        });
    }

    track(event) {
        if (typeof gtag === "function") { 
            gtag('event', 'apply', {
                'vacancy': event.target.dataset.track,
            });
        }
    }
}